import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle, XCircle, SpinnerGap } from "@phosphor-icons/react";

export default function VerifyEmail() {
  const { token } = useParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    api.get(`/auth/verify-email/${token}`).then(() => setState("ok")).catch(() => setState("error"));
  }, [token]);

  return (
    <div className="min-h-[100dvh] bg-[#F7F8F9] flex items-center justify-center px-6">
      <div className="text-center max-w-sm" data-testid="verify-email-panel">
        {state === "loading" && <SpinnerGap size={40} className="animate-spin mx-auto text-[#1F6FE5]" />}
        {state === "ok" && (
          <>
            <CheckCircle size={56} weight="fill" className="mx-auto mb-4 text-emerald-500" />
            <h1 className="font-display font-bold text-2xl tracking-tight mb-2">Email verified</h1>
            <p className="text-zinc-500 mb-6">Your organisation is verified and can now publish elections.</p>
            <Link to="/app" className="inline-block px-5 py-2.5 bg-[#1F6FE5] text-white rounded-md font-semibold">Go to dashboard</Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle size={56} weight="fill" className="mx-auto mb-4 text-red-500" />
            <h1 className="font-display font-bold text-2xl tracking-tight mb-2">Link invalid</h1>
            <p className="text-zinc-500">This verification link is invalid or has already been used.</p>
          </>
        )}
      </div>
    </div>
  );
}
